module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921135651_T.116f6a5c.jpg";